import { createSlice } from '@reduxjs/toolkit';

//Sliceの作成
export const trafficConfirmationScreenSlice = createSlice({
    name: 'impact',
    initialState: {
        carItem: true,
        personItem: true,
        morning: false,
        afternoon: false,
        night: false,
        holiday: false,
        morningSpecific: false,
        afternoonSpecific: false,
        nightSpecific: false,
    },

    //toolKitを利用した値変更処理
    reducers: {
        setConfirmationData: (state, action) => {
            return action.payload;
        },
    }
});

export const {
    setConfirmationData,
} = trafficConfirmationScreenSlice.actions;
export default trafficConfirmationScreenSlice.reducer;